<script setup lang="ts"></script>

<template>
    <div>
        <NuxtPwaManifest />
        <NuxtRouteAnnouncer />
        <NuxtLoadingIndicator />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
        <UNotifications />
    </div>
</template>
